export default __webpack_public_path__ + "static/media/parksprings.1e5ac81b.png";